import callApi from 'utils/callApi'

export const getBookingDetails = (slotId: string): Promise<SelectedSlot> =>
  callApi<SelectedSlot>({
    endpoint: `/slots/${slotId}`,
    method: 'get',
  })
